import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { desktop_small, mobile_xl } from '../../../global/mediaQueryMixin';
import { HideScrollbar } from '../../../global/commonStyle';
interface Props {
  isBorderRadius?: boolean;
  isPayment?: boolean;
  isProject?: boolean;
  isReportInvoice?: boolean;
  isTasks?: boolean;
  isLoading?: boolean;
}

const Table = styled.table<Props>`
  border-collapse: collapse;
  width: 100%;
  border-style: hidden;
  border-radius: var(--border-radius-8);
  background: var(--background-primary);
  td {
    border: 0.5px solid var(--border-primary);
    text-align: left;
    padding: var(--space-10) var(--space-12);
    ${Typography.body_md_medium}
    color: var(--text-primary);
    ${(props) =>
      props.isTasks &&
      css`
        white-space: nowrap;
      `}
    ${(props) =>
      props.isReportInvoice &&
      css`
        white-space: nowrap;
      `}
  }
  th {
    border: 0.5px solid var(--border-primary);
    text-align: left;
    padding: var(--space-10) var(--space-12);
    ${Typography.body_md_medium}
    text-transform: uppercase;
    color: var(--text-secondary);
    background-color: var(--background-tertiary);
    border-radius: var(--border-radius-0);
    :last-child {
      border-radius: var(--border-radius-0) var(--border-radius-8) var(--border-radius-0) var(--border-radius-0);
    }
    :first-child {
      border-radius: var(--border-radius-8) var(--border-radius-0) var(--border-radius-0) var(--border-radius-0);
    }
  }
  tr td:first-child {
    ${(props) =>
      props.isPayment &&
      css`
        width: 100px;
      `}
    ${(props) =>
      props.isProject &&
      css`
        width: 146px;
        cursor: pointer;
      `}
    ${(props) =>
      props.isReportInvoice &&
      css`
        width: 76px;
      `}
  }
  tr td:last-child {
    ${(props) =>
      (props.isPayment || props.isReportInvoice) &&
      css`
        text-align: right;
        width: 146px;
      `}
  }
  tr th:last-child {
    ${(props) =>
      (props.isPayment || props.isReportInvoice) &&
      css`
        text-align: right;
      `}
  }
  ${(props) =>
    props.isReportInvoice &&
    css`
      th:nth-last-child(2),
      td:nth-last-child(2) {
        text-align: right;
      }
    `}
  tr {
    .paid {
      color: var(--accent-success);
    }
    .overDue {
      color: var(--accent-error);
    }
    .pending {
      color: var(--accent-caution);
    }
    .draft {
      color: var(--text-secondary);
    }
    .partiallyPaid {
      color: var(--accent-secondary);
    }
  }
  .task-name {
    white-space: normal;
  }
  .sub-row {
    color: var(--text-secondary);
  }
  .leave-link {
    ${Typography.body_md_medium}
    color: var(--text-secondary);
    cursor: pointer;
  }
  .join-link {
    ${Typography.body_md_medium}
    color: var(--brand-primary);
    cursor: pointer;
  }
  .first-column {
    width: 388px;
  }
  .second-column {
    width: 170px;
    ${desktop_small(css`
      width: 190px;
    `)}
  }
  .third-column {
    width: 170px;
    ${desktop_small(css`
      width: 150px;
    `)}
  }
  .forth-column {
    width: 74px;
  }
  ${mobile_xl(css<Props>`
    ${(props) =>
      props.isPayment &&
      css`
        white-space: nowrap;
      `}
    tr td:last-child {
      ${(props) =>
        props.isPayment &&
        css`
          text-align: left;
          width: 100%;
        `}
    }
  `)}
`;

const BottomData = styled.div<Props>`
  max-width: 154px;
  min-width: 154px;
  width: 100%;
  ${mobile_xl(css`
    max-width: unset;
  `)}
  height: 100%;
  ${(props: Props) =>
    props.isLoading &&
    css`
      opacity: 0.8;
      cursor: default;
      pointer-events: none;
    `}
`;

const TaskPending = styled.div`
  color: var(--accent-error);
  width: 146px;
  ${Typography.body_md_medium}
`;

const TaskDone = styled.p`
  color: var(--accent-success);
  width: 146px;
  ${Typography.body_md_medium}
  margin: var(--space-0);
`;

const TaskNameLink = styled.span`
  color: var(--text-primary);
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const CustomItemDiv = styled.div`
  ${HideScrollbar}
`;
export { Table, BottomData, TaskDone, TaskPending, TaskNameLink, CustomItemDiv };
